import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { isStagesLockedError, STAGES_LOCKED_MESSAGE } from "../utils/lock.ts";
import { stageKeys } from "../utils/query-keys.ts";

export function useStagesLockedGuard(constructionId: string | undefined) {
	const queryClient = useQueryClient();

	return (err: unknown): boolean => {
		if (!isStagesLockedError(err)) return false;
		queryClient.invalidateQueries({ queryKey: stageKeys.list(constructionId) });
		toast.error(STAGES_LOCKED_MESSAGE);
		return true;
	};
}
